import { styled } from '@grupoboticario/flora-react'

export const Page = styled('main', {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  minHeight: '100vh',
  paddingTop: '$10',
  paddingBottom: '$4',
  gap: '$6',
  backgroundColor: '$backgroundPrimary'
})

export const ContentSection = styled('div', {
  width: '100%'
})

export const ContentInner = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '$6',
  width: '100%',
  maxWidth: '390px',
  margin: '0 auto',
  textAlign: 'center',

  '@tablet': {
    maxWidth: '560px'
  }
})

export const IllustrationSection = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  margin: '$10 0 $6 0'
})

export const Illustration = styled('img', {
  width: '215px',
  height: 'auto'
})

export const ActionsSection = styled('div', {
  width: '100%',
  marginTop: 'auto'
})

export const ActionsInner = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$2',
  width: '100%',
  maxWidth: '390px',
  margin: '0 auto',

  '@tablet': {
    maxWidth: '560px'
  }
})
